import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { Observable } from "rxjs";
import { getBackgroundImageStyles } from "src/app/shared/functions/ng-style-utils";
import type { Swiper } from "swiper";
import { contentListItem } from "../util";

const BREAKPOINTS = [
  { sliderSize: 3, minWidth: 1200, maxWidth: 99999 },
  { sliderSize: 3, minWidth: 900, maxWidth: 1200 },
  { sliderSize: 3, minWidth: 700, maxWidth: 900 },
  { sliderSize: 2, minWidth: 500, maxWidth: 700 },
  { sliderSize: 1, minWidth: 0, maxWidth: 500 },
];

@Component({
    selector: "app-image-slider-with-descriptions",
    templateUrl: "./image-slider-with-descriptions.component.html",
    styleUrls: ["./image-slider-with-descriptions.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ImageSliderWithDescriptionsComponent implements OnInit {
  @Input() items: Observable<contentListItem[]>;
  swiper: Swiper;

  constructor(private cdr: ChangeDetectorRef) {}
  ngOnInit(): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.

    this.items.subscribe((res) => console.log("items",res));
  }

  slidesPerView() {
    let elWidth = (this.swiper?.el as HTMLElement)?.clientWidth ?? 0;

    return BREAKPOINTS.find(
      (bkpt) => bkpt.minWidth <= elWidth && bkpt.maxWidth > elWidth
    ).sliderSize;
  }
  onSwiper(ev: CustomEvent) {
    this.swiper = ev.detail[0];
    this.swiper.on("slideChange", () => this.cdr.detectChanges());
  }
  navigateTo(i: number) {
    this.swiper.slideTo(i);
  }
  getImgStyle(url) {
    return url?.length > 0
      ? getBackgroundImageStyles(0, url)
      : { background: "#ddd" };
  }

  getCallToAction(type: string): string {
    switch (type) {
      case "Dashboard":
        return "View Dashboard";
      case "Video":
        return "Watch this video";
      case "Podcast":
        return "Listen to this podcast";
      case "Gallery":
        return "View this gallery";
      case "Link":
        return "Visit this link";
      case "File":
        return "Download this file";
      case "Page":
        return "View this page";
      case "Question":
        return "Read this Q&A";
      case "Virtual Tour":
        return "Take this virtual tour";
      case "Story":
      default:
        return "Read this story";
    }
  }
}
